import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGridView,
  useSub,
  usePub,
} from "@neumetric/blueprint-lib/components";
import { mitigatorActions, getReferencesByStatus } from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const referenceColumns = [
  {
    dataIndex: "reference_id",
    typeRepresentation: "LINK",
    title: "Reference ID",
    width: "40%",
  },
  {
    dataIndex: "name",
    typeRepresentation: "TEXT",
    title: "Reference",
    width: "60%",
    showTooltip: true,
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "active";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorReferenceTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _ref = React.useRef(null);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });
  const ReferenceList =
    useSelector(
      getReferencesByStatus.bind(null, state.activeSubmenu.toLowerCase())
    ) || [];

  useEffect(() => {
    fetchReferences();
  }, []);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };

    options.columns = referenceColumns;
    options.className = "w-374-px";

    return options;
  }, [state.activeSubmenu]);

  const fetchReferences = () => {
    dispatch(mitigatorActions.fetchReferences());
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchReferences();
  };

  return (
    <div
      className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`}
      ref={_ref}
    >
      <DataGridView
        columns={dvgOptions.columns}
        dataSource={ReferenceList.map((rfr) => ({
          reference_id: rfr.reference_id,
          id: rfr.id,
          name: rfr.name,
        }))}
        pagination={{
          pageSize: 9,
          totalCount: ReferenceList?.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          if (column.dataIndex === "reference_id") {
            return {
              onLinkClick: () => {
                const p = new URLSearchParams(window.location.search);
                p.set("tab", (state.activeSubmenu || "active").toLowerCase());
                p.set("open", "view-panel");
                p.set("id", record.id);
                p.set("_ts", Date.now());

                navigate(`${window.location.pathname}?${p.toString()}`);
              },
            };
          }
          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">
            There are no {state.activeSubmenu.toLowerCase()} references right
            now!
          </span>
        }
      />
    </div>
  );
};
